import { render, staticRenderFns } from "./ElWeekPicker.vue?vue&type=template&id=5e122f98&"
import script from "./ElWeekPicker.vue?vue&type=script&lang=ts&"
export * from "./ElWeekPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports